
























































// Base Components & Types
import { Component, Watch, Mixins } from 'vue-property-decorator';
import Pagination from '@/mixins/pagination';
import { Card, Input, Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import productService from '@/services/ProductService';
import { signedUploadService } from '@/services/SignedUploadService';
// GQL
import fetchProductsQuery from '@/graphql/queries/FetchProducts.gql';
// Vue components
import Callout from '@/components/Callout.vue';
import NavBar from '@/components/layout/NavBar.vue';
import ProductUpsert from '@/components/modals/ProductUpsert.vue';

@Component({
  components: {
    'el-card': Card,
    'el-input': Input,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    'product-upsert-modal': ProductUpsert,
    Callout
  },
  apollo: {
    products: {
      prefetch: true,
      debounce: 300,
      query: fetchProductsQuery,
      variables() {
        return {
          productArgs: {
            customerOrganizationId: this.$route.params.id,
            search: this.searchText
          }
        };
      },
      update(data) {
        return data && data.products;
      }
    }
  }
})

export default class ProductsList extends Mixins(Pagination) {
  public isModalOpen = false;
  public searchText = '';
  public searching = false;
  public $refs!: { fileInput: HTMLInputElement};
  public editingProduct = null;
  public csvSource = 'shippio';
  private emptyProduct = {
    id: null,
    name: '',
    sku: null,
    serialNumber: null,
    category: null,
    url: null,
    price: null,
    currency: '',
    weight: null,
    length: null,
    width: null,
    height: null,
    countryOfOrigin: '',
    attachments: []
  };

  get orgId(): string {
    return this.$route.params.id;
  }

  public newAction(command: string) {
    switch (command) {
      case 'openModal':
        this.editingProduct = this.emptyProduct;
        this.isModalOpen = !this.isModalOpen;
        break;
      case ('shippio'):
        this.importCSV(command);
        break;
    }
  }

  private importCSV(csvSource: string): void {
    this.csvSource = csvSource;

    this.$refs.fileInput.click();
  }

  public fileAdd(e: Event): void {
    const files = this.$refs.fileInput.files || [];
    for (let i = 0; i < files.length; i += 1) { // tslint:disable-line
      const file = files[i];
      signedUploadService.startClientUpload(file)
        .then((resFields) => {
          productService.importProducts(resFields.key, this.$route.params.id, this.csvSource)
            .then(() => {
              // @ts-ignore
              this.$refs.fileInput.value = '';
              this.$apollo.queries.products.refetch();
            });
        })
        .catch((er: any) => {
          // @ts-ignore
          this.$refs.fileInput.value = '';
          this.$store.commit('Alert/addAlert', { type: 'error', message: this.$t('error.push') });
        });
    }
  }

  private async deleteProduct(product) {
    if (!product.id || !window.confirm(this.$t('products.confirm-deletion', { name: product.name }).toString())) {
      return;
    }

    try {
      await productService.deleteProduct(product.id);
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.$apollo.queries.products.refetch();
    }
  };

  private cancel() {
    this.editingProduct = {
      customerOrganizationId: this.$route.params.id,
      id: null,
      name: '',
      sku: null,
      serialNumber: null,
      category: null,
      url: null,
      price: null,
      currency: '',
      weight: null,
      length: null,
      width: null,
      height: null,
      countryOfOrigin: '',
      attachments: []
    };
    this.isModalOpen = false;
  }

  private submit() {
    this.editingProduct = null;
    this.isModalOpen = false;
    this.$apollo.queries.products.refetch();
  }

  private updateProduct(product) {
    this.editingProduct = { ...product };
    this.isModalOpen = true;
  }
}
